import 'react-native-gesture-handler';
import React, { useState, useEffect, Suspense } from 'react';
import { StatusBar } from 'expo-status-bar';
import { StyleSheet, SafeAreaView } from 'react-native';
import {
  Center,
  NativeBaseProvider,
  Flex,
  Spacer,
  Button,
  View,
  SearchIcon,
  FavouriteIcon,
  Spinner
} from "native-base";
import { NavigationContainer, getStateFromPath } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import Ionicons from '@expo/vector-icons/Ionicons';
import { theme } from './Theme';
import HomeScreen from './src/screens/HomeScreen';

const AcceptDeclineScreenLazy = React.lazy(() => import('./src/screens/AcceptDeclineScreen'));
const SelectFlavorScreenLazy = React.lazy(() => import('./src/screens/SelectFlavorScreen'));
const SelectResponseScreenLazy = React.lazy(() => import('./src/screens/SelectResponseScreen'));
const EditResponseScreenLazy = React.lazy(() => import('./src/screens/EditResponseScreen'));
const PrivacyPolicyScreenLazy = React.lazy(() => import('./src/screens/PrivacyPolicyScreen'));
const TermsOfServiceScreenLazy = React.lazy(() => import('./src/screens/TermsOfServiceScreen'));
const PostScreenLazy = React.lazy(() => import('./src/screens/PostScreen'));
const CardScreenLazy = React.lazy(() => import('./src/screens/CardScreen'));

const Loading = () => (
  <Center bg="white" w="100%" h="100%" justifyContent="center">
    <Spinner></Spinner>
  </Center>
)

const lazyScreen = (LazyComponent, props) => {
  return (
    <Suspense fallback={
      <Loading />
    }>
      <LazyComponent {...props} />
    </Suspense>
  )
}

// const AcceptDeclineScreen = (props) => (
//   <Suspense fallback={
//     <Loading />
//   }>
//     <AcceptDeclineScreenLazy {...props} />
//   </Suspense>
// );

const AcceptDeclineScreen = (props) => lazyScreen(AcceptDeclineScreenLazy, props);
const SelectFlavorScreen = (props) => lazyScreen(SelectFlavorScreenLazy, props);
const SelectResponseScreen = (props) => lazyScreen(SelectResponseScreenLazy, props);
const EditResponseScreen = (props) => lazyScreen(EditResponseScreenLazy, props);
const PrivacyPolicyScreen = (props) => lazyScreen(PrivacyPolicyScreenLazy, props);
const TermsOfServiceScreen = (props) => lazyScreen(TermsOfServiceScreenLazy, props);
const PostScreen = (props) => lazyScreen(PostScreenLazy, props);
const CardScreen = (props) => lazyScreen(CardScreenLazy, props);


// import AcceptDeclineScreen from './src/screens/AcceptDeclineScreen';
// import SelectFlavorScreen from './src/screens/SelectFlavorScreen';
// import SelectResponseScreen from './src/screens/SelectResponseScreen';
// import EditResponseScreen from './src/screens/EditResponseScreen';
// import PrivacyPolicyScreen from './src/screens/PrivacyPolicyScreen';
// import TermsOfServiceScreen from './src/screens/TermsOfServiceScreen';
// import PostScreen from './src/screens/PostScreen';
// import CardScreen from './src/screens/CardScreen';

import ScreenTemplate from './src/components/ScreenTemplate';
import Header from './src/components/Header';

const Stack = createStackNavigator();
const navigationRef = React.createRef();

const config = {
  screens: {
    CardScreen: 'tool/birthday-card-generator',
    InviteResponseScreen: 'tool/respond-to-invite',
    SelectFlavorScreen: 'tool/respond-to-invite/style',
    SelectResponseScreen: 'tool/respond-to-invite/select-response',
    EditResponseScreen: 'tool/respond-to-invite/send',
    PrivacyPolicyScreen: 'privacy-policy',
    TermsOfServiceScreen: 'terms',
    PostScreen: 'post',
  }
}

const linking = {
  prefixes: ['invitemenot://', 'https://invitemenot.com'],
  config,
  getStateFromPath: (path, options) => {
    console.log('Getting state for path: ', path);
    const state = getStateFromPath(path, options);
    console.log('state:', state);
    return state;
  },
};

const App = (props) => {

  const isDevelopment = process.env.NODE_ENV === 'development';

  const postUris = [
    'post1',
    'post2',
    'post3'
  ];

  // const linking = {
  //   prefixes: ['invitemenot://', 'https://invitemenot.com'],
  //   config,
  //   getStateFromPath: (path, options) => {
  //     console.log('Getting state for path: ', path);
  //     const state = getStateFromPath(path, options);
  //     console.log('state:', state);
  //     return state;
  //   },
  //   // getStateFromPath: (path, options) => {
  //   //   console.log('Path:', path);
  //   //   // replace the "main" part of the route, keeping the "params" part intact
  //   //   // e.g. 'me?showName=true' -> 'user?showName=true'
  //   //   if (path.startsWith('/tool/respond-to-invite')) {
  //   //     path = 'tool/response-to-invite';
  //   //   }
  //   //   if (isDevelopment) {
  //   //     console.log('Path is:', path);
  //   //     console.log('options:', options);
  //   //   }
  //   //   let state = getStateFromPath(path, options);
  //   //   if (!state) {
  //   //     // Try to match a post
  //   //     if (postUris.includes(path.substring(1))) {
  //   //       state = getStateFromPath('/post', options);
  //   //       state.routes[0].path = path;
  //   //     }
  //   //   }
  //   //   return state;
  //   // },
  // };

  if (isDevelopment) {
    console.log(process.env);
  }

  const titlePrefix = 'Invite Me Not -';

  return (
    <NativeBaseProvider theme={theme}>
      <NavigationContainer
        linking={linking}
        ref={navigationRef}>
        <Stack.Navigator
          lazy={false}
          screenOptions={{
            headerShown: false,
            // header: Header,
            animationEnabled: false,
          }}
        >
          {/* <Stack.Screen
            name="HomeScreen"
            component={HomeScreen}
            options={{ title: 'Invite Me Not' }}
          /> */}
          <Stack.Screen
            name="CardScreen"
            component={CardScreen}
            options={{ title: `${titlePrefix} Create Card` }}
          />
          <Stack.Screen
            name="InviteResponseScreen"
            component={AcceptDeclineScreen}
            options={{ title: `${titlePrefix} Respond to an invitation` }}
          />
          <Stack.Screen
            name="SelectFlavorScreen"
            component={SelectFlavorScreen}
            options={{ title: `${titlePrefix} Select response style` }}
          />
          <Stack.Screen
            name="SelectResponseScreen"
            component={SelectResponseScreen}
            options={{ title: `${titlePrefix} Pick a response` }}
          />
          <Stack.Screen
            name="EditResponseScreen"
            component={EditResponseScreen}
            options={{ title: `${titlePrefix} Edit and send!` }}
          />

          {/* <Stack.Screen
            name="PrivacyPolicyScreen"
            component={PrivacyPolicyScreen}
            options={{ title: `${titlePrefix} Privacy Policy` }}
          />
          <Stack.Screen
            name="TermsOfServiceScreen"
            component={TermsOfServiceScreen}
            options={{ title: `${titlePrefix} Terms of Service` }}
          /> */}
          <Stack.Screen
            name="PostScreen"
            component={PostScreen}
            options={{ title: `${titlePrefix} Post` }}
          />
        </Stack.Navigator>
      </NavigationContainer>
    </NativeBaseProvider>
  );
};

export default App;